import { trackPromise } from 'react-promise-tracker';
import {fetchWithAuth} from './fetchWithAuth'
export async function getCampanaEspecial(cif, userToken) {
    return trackPromise(
        fetchWithAuth(
            'https://t41bx8uqf6.execute-api.us-east-2.amazonaws.com/prod/votacion/campana_especial',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'authorizationToken': userToken
                },
                body: JSON.stringify({ CIF: cif })
            }
        )
    );
}